import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { LoggedInUserAccessDetails } from '../models/loggedInUserModel';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService {


  constructor(
    private authService: AuthService
  ) { }

  canActivate(route: ActivatedRouteSnapshot): boolean {
    if (this.authService.Authorization$.value != '' && localStorage.getItem('Authorization') != null && this.authService.Authorization$.value != localStorage.getItem('Authorization')) {
      return false;
    }
    if (this.authService.Authorization$.value == '' && localStorage.getItem('Authorization') == null) {
      return false;
    }
    else {
      if (this.authService.Authorization$.value == '') {
        this.authService.Authorization$.next(localStorage.getItem('Authorization') || '');
        this.authService.hostName$.next(localStorage.getItem('hostName') || '');
        this.authService.IsTenantUser$.next(Boolean(localStorage.getItem('IsTenantUser')));
        this.authService.IsAdminUser$.next(Boolean(localStorage.getItem('IsAdminUser')));
        this.authService.IsMerchantUser$.next(Boolean(localStorage.getItem('IsMerchantUser')));
        this.authService.UserName$.next(localStorage.getItem('UserName') || '');
        this.authService.Session$.next(localStorage.getItem('Session') || '');
        this.authService.loginHostName$.next(localStorage.getItem('loginHostName') || '');
        this.authService.tenantId$.next(localStorage.getItem('tenantId') || '');
        this.authService.stage$.next(localStorage.getItem('stage') || '');
        this.authService.AccessDetails$.next(JSON.parse(localStorage.getItem('accessDetails') || ''));
      }
      return true;
    }
  }
}
